import React, { Fragment,useEffect }  from 'react';
import Breadcrumb from './components/breadcrumb';
import List from './components/list';
import useGlobal from './store';
import Search from "./components/search";

export default () => {
  const [globalState, globalActions] = useGlobal();
  useEffect(() => {
    const { pageInfo } = globalActions;
    pageInfo();
  }, [globalActions]);
  return (
    <Fragment>
      <Breadcrumb />
        <Search
            setSearchForm= {globalActions.setSearchForm}
            searchClick= {globalActions.pageInfo}
            searchForm = {globalState.searchForm}
        />
      <List
        pageDataInfo = {globalState.pageDataInfo}
        changePageInfo= {globalActions.pageInfo}
       />
    </Fragment>
  )
}
